<template>
  <div id="user-edituser">
    <el-dialog
      v-loading="imgload"
      title="修改资料"
      :visible.sync="show"
      :close-on-click-modal="false"
      element-loading-text="头像上传中"
    >
      <div>
        <div class="img">
          <template v-if="imgpath">
            <img :src="imgpath" alt>
          </template>
          <template v-else>
            <img src="@/assets/images/avatar.png" alt>
          </template>
          <span
            style="color:#000;font-weight:bold;cursor:pointer;"
            class="el-icon-plus"
            @click="imgUp"
          />
        </div>
        <el-form ref="form" :model="formInline" label-width="80px" size="mini" class="forms">
          <el-form-item label="昵称:" :rules="[{ required: true, message: '昵称不能为空'}]" prop="name">
            <el-input v-model.trim="formInline.name" maxlength="20" />
          </el-form-item>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dilongfooter"
        style="padding:5px 0;display: flex;justify-content: space-around;"
      >
        <el-button type="primary" size="mini" @click="show = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="edituser">确 定</el-button>
      </div>
    </el-dialog>
    <div style="display:none;">
      <el-upload
        accept=".jpeg, .jpg, .png"
        :action="quest.userEditupImg"
        :before-upload="handleChange"
        :on-success="succChange"
        :on-error="errorChnage"
      >
        <el-button ref="upimg" size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
import quest from '../../api/user'
export default {
  data() {
    return {
      quest,
      imgpath: '',
      show: false,
      imgload: false,
      formInline: {
        name: ''
      },
      userID: ''
    }
  },
  watch: {
    'formInline.name': {
      handler(val) {
        this.formInline.name = val.replaceAll(' ', '')
      },
      deep: true
    }
  },
  created() {
    this.$on('dilong-editUser', (val, img, name) => {
      this.show = val
      this.imgpath = img
      this.$set(this.formInline, 'name', name)
    })
  },
  mounted() {
    const user = localStorage.getItem('userInfo')
    if (user) {
      const id = JSON.parse(user)
      this.userID = id.fuserId || ''
    }
  },
  methods: {
    handleChange(...test) {
      this.imgload = true
    },
    errorChnage() {
      this.imgload = false
      this.$message({
        showClose: true,
        message: '头像上传失败',
        type: 'error'
      })
    },
    succChange(val) {
      this.imgload = false
      this.imgpath = val.imgUrlList[0].oriUrl
    },
    imgUp() {
      this.$refs.upimg.$el.click()
    },
    edituser() {
      this.$refs.form.validate(val => {
        if (val && this.userID) {
          quest
            .userEdit({
              fHeadPortraitPath: this.imgpath,
              fNickName: this.formInline.name,
              fUserId: this.userID
            })
            .then(res => {
              if (res.result) {
                this.$parent.initUser()
                this.reset()
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg || '修改失败',
                  type: 'error'
                })
              }
            })
        }
      })
    },
    reset() {
      this.imgpath = ''
      this.imgload = false
      this.formInline = {
        name: ''
      }

      this.show = false
    }
  }
}
</script>

<style lang="scss" >
#user-edituser {
  .el-dialog {
    width: 484px;
    height: 243px;
    .el-dialog__header {
      text-align: center;
    }
    .img {
      img {
        height: 72px;
        width: 72px;
        vertical-align: center;
        object-fit: contain;
      }
      float: left;
      margin-left: 18px;
    }
    .forms {
      width: 340px;
      float: right;
      padding-top: 20px;
      padding-right: 22px;
    }
    .dilongfooter {
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0;
      padding-top: 25px;
    }
  }
}
</style>
